import { Types } from '@store/types';

import { checkAnyUserType } from '@utils/Util';

const isAdminOrProjectDirector = () => checkAnyUserType(['ADMIN', 'PROJECT_DIRECTOR']);

const initialState = {
	headings: [],
	isAllColumnVisible: !isAdminOrProjectDirector(),
	isCriticalColumnVisible: isAdminOrProjectDirector(),
	isBrandColumnVisible: true,
	isStyleColumnVisible: true,
	isFabricColumnVisible: true,
	isSweaterColumnVisible: false,
	isPOColumnVisible: true,
	isSCColumnVisible: true,
	isETDColumnVisible: true,
	isTnaStatusColumnVisible: true,
	isExFactoryColumnVisible: true,
	isSPColumnVisible: true,
	isDeliveryColumnVisible: true,
	isInspectionColumnVisible: true
};

const OrderDashboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_ORDER_DASHBOARD_TABLE_HEADINGS:
			return {
				...state,
				headings: action.payload.map((item) => ({ ...item, isColumnVisible: false }))
			};
		case Types.TOGGLE_ORDER_DASHBOARD_TABLE_COLUMN:
			return {
				...state,
				headings: state.headings.map((item) => {
					if (item.stageConstants === action.payload) {
						return { ...item, isColumnVisible: !item.isColumnVisible };
					} else {
						return item;
					}
				})
			};
		case Types.TOGGLE_ORDER_DASHBOARD_TABLE_GENERAL_COLUMN:
			return { ...state, [action.payload]: !state[action.payload] };
		default:
			return state;
	}
};

export default OrderDashboardReducer;
